import { DatePicker } from "@material-ui/pickers";
import {
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
} from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
import { VehicleSelectionList } from "../vehicle-mileage-summary/VehicleSelectionList";

interface Props extends RouteComponentProps {}

export const LocationsHistoryReport = (props: Props) => {
  useAuthenticated();

  return (
    <ReportForm
      reportName="locations-history-report"
      {...props}
      title="resources.reports.locationsHistory.name"
      submitMethod={(x) => x.reportLocationhistoryreportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <ReferenceInput
        reference={resourceNames.ADMIN_COMPANIES}
        validate={required()}
        source="companyId"
      >
        <SelectInput />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          return (
            formData["companyId"] && (
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  return (
                    formData["companyId"] && (
                      <VehicleSelectionList
                        source="vehicles"
                        filter={{ companyId: formData["companyId"] }}
                      />
                    )
                  );
                }}
              </FormDataConsumer>
            )
          );
        }}
      </FormDataConsumer>
    </ReportForm>
  );
};
